import React, { useState, useEffect } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import axios from "axios";
import {
	Card,
	CardContent,
	Typography,
	TextField,
	Select,
	MenuItem,
	Button,
	Grid,
	FormControl,
	InputLabel,
	Box,
	Modal,
	Input,
} from "@mui/material";
import Footer from "../Footer/Footer";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import { format, formatISO } from "date-fns";
// import './CustomDatePicker.css'; // Custom CSS for styling
// import { FaCalendarAlt } from 'react-icons/fa';
import config from "../config";
import Tooltip from "bootstrap/js/dist/tooltip";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CircularProgress from "@mui/material/CircularProgress";
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';

const ReservationSchedule = () => {
	const [events, setEvents] = useState([]);
	const [reservedBy, setReservedBy] = useState("");
	const [purposeOfMeeting, setPurposeOfMeeting] = useState("");
	const [noOfPersons, setNoOfPersons] = useState(0);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const [remarks, setRemarks] = useState("");
	const [selectedEvent, setSelectedEvent] = useState(null);
	const [openModal, setOpenModal] = useState(false);
	const [openModalRequest, setOpenModalRequest] = useState(false);
	const [openModalEdit, setOpenModalEdit] = useState(false);
	const [loggedInUser, setLoggedInUser] = useState(null);
	const [EmpCode, setEmpCode] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);
	const [boardroomData, setBoardroomData] = useState({});
	const [data, setData] = useState(null);
	const [selectedLocation, setSelectedLocation] = useState("");
	const [roomName, setRoomName] = useState("");
	const [roomId, setRoomId] = useState("");

	//OLD
	const today = dayjs().startOf("day");
	const minTime = dayjs().set('hour', 8).set('minute', 0).set('second', 0);
	const maxTime = dayjs().set('hour', 18).set('minute', 30).set('second', 0);

	//NEW
	const [loadingEvents, setLoadingEvents] = useState(true);
	// const today = dayjs().startOf("day").toDate();
	// const minTime = dayjs().set('hour', 8).set('minute', 0).set('second', 0).toDate();
	// const maxTime = dayjs().set('hour', 19).set('minute', 0).set('second', 0).toDate();

	const [maxPersons, setMaxPersons] = useState(0);
	const [personsError, setPersonsError] = useState('');
	const [editMaxPersons, setEditMaxPersons] = useState(0);
	const [editPersonsError, setEditPersonsError] = useState('');

	const boardroomCapacities = {
		'Think Tank': 10,
		'Idea Verse': 10,
		'XChange': 8,
		'Evotorium': 117,
		'Training Hall': 50,
		'Blue Ocean': 16,
		'Innobrate': 10,
		'Evolve': 6,
		'Passion (Executive)': 8,
		'Think Big (Executive)': 8,
		'Loop B': 4,
		'5th Floor Office 506': 8,
	};

	useEffect(() => {
		if (selectedLocation === 'HeadOffice' && roomName) {
			setMaxPersons(boardroomCapacities[roomName] || 0);
		} else if (selectedLocation === 'Factory' && roomName) {
			setMaxPersons(boardroomCapacities[roomName] || 0);
		} else {
			setMaxPersons(0);
		}
	}, [selectedLocation, roomName]);

	useEffect(() => {
		if (selectedEvent?.selectedLocation === 'HeadOffice' && selectedEvent?.roomName) {
			setEditMaxPersons(boardroomCapacities[selectedEvent.roomName] || 0);
		} else if (selectedEvent?.selectedLocation === 'Factory' && selectedEvent?.roomName) {
			setEditMaxPersons(boardroomCapacities[selectedEvent.roomName] || 0);
		} else {
			setEditMaxPersons(0);
		}
	}, [selectedEvent?.selectedLocation, selectedEvent?.roomName]);

	const handleRoomNameChange = (e) => {
		const selectedId = parseInt(e.target.value); // kyunki id number hai
		const selectedRoom = availableBoardrooms.find(room => room.id === selectedId);

		if (selectedRoom) {
			setRoomId(selectedRoom.id); // id set karo
			setRoomName(selectedRoom.name); // name set karo
		}
	};

	const handleNoOfPersonsChange = (e) => {
		const value = e.target.value;
		let parsedValue = parseInt(value);

		if (value === '') {
			setNoOfPersons(0);
			setPersonsError('');
		} else if (isNaN(parsedValue)) {
			setNoOfPersons(0);
			setPersonsError('');
		} else {
			setNoOfPersons(parsedValue);
			if (parsedValue > maxPersons) {
				setPersonsError(`Maximum ${maxPersons} persons allowed.`);
			} else {
				setPersonsError('');
			}
		}
	};

	const handleNoOfPersonsChangeEdit = (e) => {
		const value = e.target.value;
		let parsedValue = parseInt(value);

		if (value === '') {
			setSelectedEvent({ ...selectedEvent, noOfPersons: 0 });
			setEditPersonsError('');
		} else if (isNaN(parsedValue)) {
			setSelectedEvent({ ...selectedEvent, noOfPersons: 0 });
			setEditPersonsError('');
		} else {
			setSelectedEvent({ ...selectedEvent, noOfPersons: parsedValue });
			if (parsedValue > editMaxPersons) {
				setEditPersonsError(`Maximum ${editMaxPersons} persons allowed.`);
			} else {
				setEditPersonsError('');
			}
		}
	};

	useEffect(() => {
		try {
			const rawAccessLevel = localStorage.getItem("Boardroom_AccessLevel");
			const accessLevel = rawAccessLevel
				? rawAccessLevel.replace(/"/g, "")
				: null;

			const storedEmpCode = localStorage.getItem("Empcode");

			if (accessLevel) {
				// console.log("Access Level:", rawAccessLevel);
				setLoggedInUser(accessLevel);
			} else {
				console.warn("Invalid AccessLevel format in localStorage.");
			}

			if (storedEmpCode) {
				setEmpCode(storedEmpCode);
				// console.log("EMP CODE", storedEmpCode)
			}
		} catch (error) {
			console.error("Error parsing localStorage data:", error);
		}
	}, []);

	useEffect(() => {
		const fetchUser = async () => {
			const Empcode = localStorage.getItem("Empcode");
			if (!Empcode) {
				setReservedBy("Guest");
				return;
			}

			try {
				const response = await axios.get(`${config.API_BASE_URL}/getUsers/${Empcode}`);
				const userData = response.data;
				setReservedBy(`${userData.EmployeeName}`);
			} catch (error) {
				console.error("Error fetching user data:", error);
				setReservedBy("Unknown User");
			}
		};

		fetchUser();
	}, []);

	useEffect(() => {
		axios
			.get(`${config.API_BASE_URL}/boardroom/getAvailableBoardrooms`)
			.then((response) => {
				if (response.data && Object.keys(response.data).length > 0) {
					setData(response.data);
				} else {
					setData({});
				}
				setLoading(false);
			})
			.catch((error) => {
				console.error("Error fetching data:", error);
				setLoading(false);
			});
	}, []);

	const availableBoardrooms = data && selectedLocation ? data[selectedLocation] || [] : [];

	// console.log("Selected Location:", selectedLocation);
	// console.log("Available Boardrooms:", availableBoardrooms);

	const fetchReservations = async () => {
		try {
			setLoadingEvents(true);
			const response = await axios.get(
				`${config.API_BASE_URL}/boardroomReservation/getReservations`
			);

			const fetchedEvents = response.data.map((res) => ({
				id: res.reservationId,
				title: res.roomName,
				selectedLocation: res.selectedLocation,
				reservedBy: res.reserveBy,
				start: new Date(res.selectedStartDate),
				end: new Date(res.selectedEndDate),
				roomId: res.roomId,
				allDay: false,
				EmpCode: res.EmpCode,
				noOfPersons: res.noOfPersons,
				purposeOfMeeting: res.purposeOfMeeting,
				status: res.status,
			}));

			console.log("BRRRRRRRRRRRRRRR", fetchedEvents);
			setEvents(fetchedEvents);
		} catch (error) {
			console.error("Error fetching reservations:", error);
		} finally {
			setLoadingEvents(false);
		}
	};

	useEffect(() => {
		// const today = new Date();
		// const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
		// const lastDayOfMonth = new Date(
		//   today.getFullYear(),
		//   today.getMonth() + 1,
		//   0
		// );

		//fetchReservations(firstDayOfMonth, lastDayOfMonth);

		fetchReservations();
	}, []);

	const formatDayjsToLocalISOString = (dayjsObj) => {
		return dayjsObj.format("YYYY-MM-DDTHH:mm:ss"); // ISO-like, but in local time
	};

	//OLD
	const isSaveDisabled =
		!selectedLocation ||
		!roomName ||
		!startDate ||
		!endDate ||
		endDate.isSame(startDate) ||
		endDate.isBefore(startDate) ||
		!noOfPersons ||
		!purposeOfMeeting;

	//NEW
	// const isSaveDisabled =
	//   !selectedLocation ||
	//   !roomName ||
	//   !startDate ||
	//   !endDate ||
	//   endDate.getTime() === startDate.getTime() ||
	//   endDate.getTime() < startDate.getTime();


	const handleBookReservation = async () => {
		if (!roomName || !startDate || !endDate || !selectedLocation || !noOfPersons || !purposeOfMeeting) {
			toast.warning("Please fill all fields!");

			return;
		}

		if (endDate.isSame(startDate) || endDate.isBefore(startDate)) {
			toast.error("End time must be after start time.");
			return;
		}

		const isConflict = events.find((event) => {
			return (
				event.title.includes(roomName) &&
				((new Date(startDate) >= new Date(event.start) &&
					new Date(startDate) < new Date(event.end)) ||
					(new Date(endDate) > new Date(event.start) &&
						new Date(endDate) <= new Date(event.end)) ||
					(new Date(startDate) <= new Date(event.start) &&
						new Date(endDate) >= new Date(event.end)))
			);
		});

		if (isConflict) {
			toast.warning(
				`The boardroom "${roomName}" is already booked from ${new Date(isConflict.start).toLocaleString()} to ${new Date(isConflict.end).toLocaleString()}.`
			);

			setSelectedLocation("");
			setRoomName("");
			setStartDate(null);
			setEndDate(null);
			setPurposeOfMeeting("");
			return;
		}


		// // ✅ Convert to plain Date objects for comparison
		// const start = new Date(startDate);
		// const end = new Date(endDate);
		// const today = start.toDateString();

		// // 🔹 1. Check if user already has a reservation today
		// const hasReservationToday = events.some(ev => {
		// 	return (
		// 		ev.EmpCode === EmpCode &&
		// 		new Date(ev.start).toDateString() === today
		// 	);
		// });

		// if (hasReservationToday) {
		// 	toast.error("You already have a reservation for today. Only one reservation is allowed per day.");

		// 	setSelectedLocation("");
		// 	setRoomName("");
		// 	setStartDate(null);
		// 	setEndDate(null);
		// 	setPurposeOfMeeting("");
		// 	return;
		// }
		const newEvent = {
			title: roomName,
			roomName,
			roomId: roomId,
			reserve: reservedBy,
			start: (new Date(startDate).toLocaleString()),
			end: (new Date(endDate).toLocaleString()),
			allDay: false,
			EmpCode: EmpCode,
			selectedLocation: selectedLocation,
			noOfPersons: noOfPersons,
			purposeOfMeeting: purposeOfMeeting,
		};

		setEvents([...events, newEvent]);

		try {
			const res = await axios.post(`${config.API_BASE_URL}/boardroomReservation/createReservation`, {
				roomName,
				reserveBy: reservedBy,
				selectedStartDate: new Date(startDate).toISOString(),
				selectedEndDate: new Date(endDate).toISOString(),
				EmpCode: EmpCode,
				selectedLocation,
				noOfPersons,
				purposeOfMeeting,
				roomId: roomId,
			});

			// toast.success(res.data?.message || `You booked "${roomName}" from ${new Date(startDate).toLocaleString()} to ${new Date(endDate).toLocaleString()}.`);
			toast.success(`You booked "${roomName}" from ${new Date(startDate).toLocaleString()} to ${new Date(endDate).toLocaleString()}.`);
			setTimeout(() => {
				window.location.reload();
			}, 3000);

			setSelectedLocation("");
			setRoomName("");
			setStartDate(null);
			setEndDate(null);
			setNoOfPersons(0);
			setPurposeOfMeeting("");
		} catch (error) {
			console.error("Error saving reservation:", error);
			// toast.success(`You booked "${roomName}" from ${new Date(startDate).toLocaleString()} to ${new Date(endDate).toLocaleString()}.`);
			// setTimeout(() => {
			// 	window.location.reload();
			// }, 2000);
		}
	};

	const handleEventClick = (clickInfo) => {
		const eventDetails = {
			title: clickInfo.event.title,
			start: clickInfo.event.start.toLocaleString(),
			end: clickInfo.event.end.toLocaleString(),
			reservedBy: clickInfo.event.extendedProps.reservedBy,
			EmpCode: clickInfo.event.extendedProps.EmpCode,
			// remarks: clickInfo.event.extendedProps.remarks,
			noOfPersons: clickInfo.event.extendedProps.noOfPersons,
			purposeOfMeeting: clickInfo.event.extendedProps.purposeOfMeeting,
			status: clickInfo.event.extendedProps.status,
			reservationId: clickInfo.event.id,
			roomName: clickInfo.event.title,
			roomId: clickInfo.event.extendedProps.roomId,
			selectedLocation: clickInfo.event.extendedProps.selectedLocation,
			extendedProps: clickInfo.event.extendedProps,
		};

		console.log("BHAI YEH LAY", { eventDetails });

		setSelectedEvent(eventDetails);
		setOpenModal(true);
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		setSelectedEvent(null);
	};

	const handleOpenModalRequest = () => {
		// console.log("Event Data:", { selectedEvent });

		setOpenModal(false);
		setOpenModalRequest(true);
	};

	const handleCloseModalRequest = () => {
		setOpenModalRequest(false);
		setSelectedEvent(null);
	};

	const handleOpenModalEdit = () => {
		setOpenModal(false);
		setOpenModalEdit(true);
	};

	const handleCloseModalEdit = () => {
		setOpenModalEdit(false);
		setSelectedEvent(null);
	};

	//const handleDateChange = (info) => {
	// const startDate = new Date(info.start);
	// const endDate = new Date(info.end);
	//fetchReservations();
	//};

	// console.log({ events }, `check state`);

	const handleDelete = async (reservationId) => {
		if (!reservationId) {
			toast.error("Something went wrong!");
			return;
		}
		const confirmDelete = window.confirm("Are you sure you want to delete this reservation?");
		if (!confirmDelete) return;

		try {
			const response = await fetch(`${config.API_BASE_URL}/boardroomReservation/deleteReservation/${reservationId}`, {
				method: "DELETE"
			});

			const result = await response.json();

			if (response.ok) {
				toast.success("Reservation deleted successfully!");
				window.location.reload();
			} else {
				console.error(result.message || "Failed to delete reservation");
			}
		} catch (error) {
			console.error("Error deleting reservation:", error);
		}
	};

	const handleEditReservation = async () => {
		setLoading(true);
		setError(null);

		try {
			const response = await axios.put(
				`${config.API_BASE_URL}/boardroomReservation/updateReservation/${selectedEvent?.reservationId}`,
				{
					selectedLocation: selectedEvent?.selectedLocation,
					roomName: selectedEvent?.roomName,
					roomId: selectedEvent?.roomId,
					reserveBy: selectedEvent?.reservedBy, // Send the updated reservedBy with "(Edited by Admin)"
					selectedStartDate: (new Date(selectedEvent?.start).toLocaleString()),
					selectedEndDate: (new Date(selectedEvent?.end).toLocaleString()),
					remarks: selectedEvent?.remarks,
					noOfPersons: selectedEvent?.noOfPersons,
					purposeOfMeeting: selectedEvent?.purposeOfMeeting,
				}
			);

			toast.success(response.data.message);

			fetchReservations();
			handleCloseModalEdit();
		} catch (err) {
			console.error("Error updating reservation:", err);
			setError(err.response?.data?.message || "Failed to update reservation");
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (selectedEvent?.selectedLocation) {
			setSelectedLocation(selectedEvent.selectedLocation);
		}
	}, [selectedEvent]);

	const handleEventMount = (info) => {
		new Tooltip(info.el, {
			title: info.event.title,
			placement: "top",
			trigger: "hover",
			container: "body",
			customClass: "custom-tooltip"
		});
	};

	useEffect(() => {
		if (startDate && endDate) {
			if (!dayjs(endDate).isSame(startDate, 'day')) {
				toast.error("End date must be on the same day as start date");
				setEndDate(null);
			}
		}
	}, [startDate, endDate]);

	return (
		<Box
			component="main"
			sx={{
				flexGrow: 1,
				padding: "10px",
				paddingLeft: "260px",
				paddingTop: "60px",
			}}
		>
			<Card
				sx={{
					width: "100%",
					borderRadius: "10px",
					borderTop: "4px solid blue",
					padding: "15px",
				}}
			>
				<Typography variant="h6" gutterBottom sx={{ padding: "5px" }}>
					Boardroom Reservation
				</Typography>

				<Grid container spacing={2} sx={{ padding: 1 }}>
					<Grid item xs={12} md={8}>
						<Card sx={{ borderRadius: 3, boxShadow: 2, background: "linear-gradient(to right, #F0F8FF, #F0F8FF)" }}>

							{loadingEvents && (
								<div style={{ textAlign: "center" }}>
									<CircularProgress size={40} thickness={4} />
									<Typography variant="body2" sx={{ mt: 1, fontWeight: "bold" }}>
										Loading reservations...
									</Typography>
								</div>
							)}
							<CardContent sx={{ padding: "10px" }}>
								<FullCalendar
									plugins={[dayGridPlugin, interactionPlugin]}
									initialView="dayGridMonth"
									events={events}
									//datesSet={handleDateChange}
									selectable={true}
									editable={true}
									height="auto"
									contentHeight="auto"
									expandRows={true}
									eventClick={handleEventClick}
									eventDidMount={(info) => {
										const eventDate = new Date(info.event.start);
										const today = new Date();
										today.setHours(0, 0, 0, 0);

										const pastColor = "#e0e0e0";
										const upcomingColor = "#fd7e14";

										info.el.style.fontSize = "1rem";
										info.el.style.fontWeight = "bold";
										info.el.style.padding = "5px";
										info.el.style.borderRadius = "8px";
										info.el.style.textAlign = "center";
										info.el.style.boxShadow = "1px 1px 5px rgb(255, 255, 255)";

										const dotEl = info.el.querySelector('.fc-daygrid-event-dot');

										if (dotEl) {
											dotEl.style.border = eventDate < today ? "4px solid #28a745" : "4px solid #3788d8";
										}
										if (eventDate < today) {
											info.el.style.backgroundColor = pastColor;
											info.el.style.color = "#a6a6a6";
										} else {
											info.el.style.backgroundColor = upcomingColor;
											info.el.style.color = "#fff";
										}

									}}
									key={events.length}
									className="custom-calendar"
									dayCellContent={(arg) => (
										<div style={{
											display: "flex",
											flexDirection: "column",
											alignItems: "center",
											justifyContent: "space-between",
											height: "100%",
											padding: "5px"
										}}>
											<span style={{
												fontSize: "1rem",
												fontWeight: "bold",
												color: "#222"
											}}>
												{arg.dayNumberText}
											</span>
										</div>
									)}
									dayHeaderClassNames="custom-day-header"
									dayHeaderContent={(arg) => (
										<div style={{
											color: "#FFFFFF",
											fontWeight: "bold",
											display: "flex",
											alignItems: "center",
											justifyContent: "center",
											textAlign: "center",
											width: "100%",
											height: "100%",
										}}>
											{arg.text}
										</div>
									)}
								/>
							</CardContent>
						</Card>
					</Grid>

					<Grid item xs={12} md={4}>
						<Card sx={{ borderRadius: 3, boxShadow: 2, padding: "10px" }}>
							<CardContent>
								<Typography variant="h6" sx={{ mb: 1 }}>
									New Reservation
								</Typography>

								<FormControl fullWidth sx={{ mb: 2 }} disabled={loading}>
									<InputLabel>Select Location</InputLabel>
									<Select
										value={selectedLocation}
										onChange={(e) => {
											setSelectedLocation(e.target.value);
											setRoomName("");
										}}
									>
										<MenuItem value="Factory">Factory</MenuItem>
										<MenuItem value="HeadOffice">Head Office</MenuItem>
									</Select>
								</FormControl>

								<FormControl fullWidth sx={{ mb: 1 }} disabled={!selectedLocation || loading}>
									<InputLabel>Board Room Name</InputLabel>
									<Select value={roomId} onChange={handleRoomNameChange}>
										{loading ? (
											<MenuItem disabled>Loading...</MenuItem>
										) : availableBoardrooms.length > 0 ? (
											availableBoardrooms.map((room) => (
												<MenuItem key={room.id} value={room.id}>
													{room.name}
												</MenuItem>
											))
										) : (
											<MenuItem disabled>No Rooms Available</MenuItem>
										)}
									</Select>
								</FormControl>

								<TextField
									fullWidth
									label="Reserved By"
									value={reservedBy}
									sx={{ mb: 1 }}
								/>

								{/* NEW */}
								{/* <div className="date-picker-wrapper">
							<label className="picker-label">Meeting Start Time/Date</label>
							<div className="picker-input-container">
								<FaCalendarAlt className="calendar-icon" />
								<DatePicker
									label="Meeting Start Time/Date"
									selected={startDate}
									onChange={(date) => setStartDate(date)}
									showTimeSelect
									dateFormat="yyyy-MM-dd h:mm aa"
									className="custom-date-picker"
									minDate={today}
									minTime={minTime}
									maxTime={maxTime}
								/>
							</div>
						</div>

						<div className="date-picker-wrapper">
							<label className="picker-label">Meeting End Time/Date</label>
							<div className="picker-input-container">
								<FaCalendarAlt className="calendar-icon" />
								<DatePicker
									label="Meeting End Time/Date"
									selected={endDate}
									onChange={(date) => setEndDate(date)}
									showTimeSelect
									dateFormat="yyyy-MM-dd h:mm aa"
									className="custom-date-picker"
									minDate={startDate || today}
									minTime={minTime}
									maxTime={maxTime}
								/>
							</div>
						</div> */}

								{/* OLD */}
								<LocalizationProvider dateAdapter={AdapterDayjs}>
									<MobileDateTimePicker
										label="Meeting Start Time/Date"
										value={startDate}
										onChange={(date) => setStartDate(date)}
										sx={{ mb: 2, width: "100%" }}
										format="YYYY-MM-DD HH:mm:ss"
										minDate={today}
										minTime={minTime}
										maxTime={maxTime}
									/>
									<MobileDateTimePicker
										label="Meeting End Time/Date"
										value={endDate}
										onChange={(date) => setEndDate(date)}
										sx={{ mb: 2, width: "100%" }}
										format="YYYY-MM-DD HH:mm:ss"
										minDate={startDate || today}
										/** 👇 add this maxDate to restrict to same day */
										maxDate={startDate ? dayjs(startDate).endOf('day') : today}
										/** 👇 optionally handle time range if needed */
										minTime={minTime}
										maxTime={maxTime}
									/>
								</LocalizationProvider>

								<TextField
									fullWidth
									label="No of Persons"
									value={noOfPersons}
									onChange={handleNoOfPersonsChange}
									sx={{ mb: 1 }}
									error={!!personsError}
									helperText={personsError}
								/>

								<TextField
									fullWidth
									label="Purpose of Meeting"
									value={purposeOfMeeting}
									onChange={(e) => setPurposeOfMeeting(e.target.value)}
									sx={{ mb: 1 }}
								/>

								<Grid container spacing={1} sx={{ mt: 1 }}>
									<Grid item xs={6}>
										<Button
											fullWidth
											variant="contained"
											color="primary"
											onClick={handleBookReservation}
											disabled={!!personsError || loading || isSaveDisabled}
										>
											Save
										</Button>
									</Grid>
									<Grid item xs={6}>
										<Button
											fullWidth
											variant="outlined"
											color="secondary"
											onClick={() => {
												setSelectedLocation("");
												setRoomName("");
												setStartDate(null);
												setEndDate(null);
												setNoOfPersons("");
												setPurposeOfMeeting("");
											}}
										>
											Reset
										</Button>
									</Grid>
								</Grid>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Card>
			<Footer />

			{/* {console.log("Hey", selectedEvent)} */}

			<Modal open={openModal} onClose={handleCloseModal}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 400,
						bgcolor: "background.paper",
						boxShadow: 24,
						p: 4,
					}}
				>
					{selectedEvent && loggedInUser && (
						<>
							<Typography variant="h6">Reservation Details</Typography>
							<hr />

							<Typography>
								<strong>Board-Room Name:</strong>
								{selectedEvent.title}
							</Typography>
							<Typography>
								<strong>Reserved By:</strong>{" "}
								{selectedEvent.extendedProps.reservedBy}
							</Typography>
							<Typography>
								<strong>Meeting Start Time/Date:</strong>{" "}
								{selectedEvent.start?.toString()}
							</Typography>
							<Typography>
								<strong>Meeting End Time/Date:</strong>{" "}
								{selectedEvent.end?.toString()}
							</Typography>
							<Typography>
								<strong>No of People:</strong>{" "}
								{selectedEvent.extendedProps?.noOfPersons}
							</Typography>
							<Typography>
								<strong>Purpose Of Meeting:</strong>{" "}
								{selectedEvent.extendedProps?.purposeOfMeeting}
							</Typography>

							<Grid container spacing={1} sx={{ mt: 2 }}>
								{loggedInUser === "ADMIN" ? (
									<>
										<Grid item xs={6}>
											<Button
												fullWidth
												variant="contained"
												color="primary"
												onClick={handleOpenModalEdit}
											>
												Edit
											</Button>
										</Grid>
										<Grid item xs={6}>
											<Button
												fullWidth
												variant="contained"
												color="error"
												onClick={() => handleDelete(selectedEvent.reservationId)}
											>
												Delete
											</Button>
										</Grid>
									</>
								) : String(selectedEvent?.extendedProps?.EmpCode) ===
									localStorage.getItem("Empcode") ? (
									<Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", gap: "10px" }}>
										<Button
											fullWidth
											variant="contained"
											color="warning"
											onClick={handleOpenModalRequest}
										>
											Request Change
										</Button>
										<Button
											fullWidth
											variant="contained"
											color="error"
											onClick={() => handleDelete(selectedEvent.reservationId)}
										>
											Cancel Reservation
										</Button>
									</Grid>
								) : null}
								<Grid item xs={12}>
									<Button
										fullWidth
										variant="outlined"
										color="secondary"
										onClick={handleCloseModal}
									>
										Close
									</Button>
								</Grid>
							</Grid>
						</>
					)}
				</Box>
			</Modal>

			{/* Edit Modal */}
			<Modal open={openModalEdit} onClose={handleCloseModalEdit}>
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 450,
						bgcolor: "background.paper",
						boxShadow: 24,
						p: 3,
						borderRadius: 2,
					}}
				>
					<Typography variant="h6" gutterBottom>
						Edit Schedule
					</Typography>

					<FormControl fullWidth sx={{ mb: 2 }} disabled={loading}>
						<InputLabel>Select Location</InputLabel>
						<Select
							value={selectedEvent?.selectedLocation || ""}
							onChange={(e) => {
								setSelectedEvent({ ...selectedEvent, selectedLocation: e.target.value })
							}}
						>
							<MenuItem value="Factory">Factory</MenuItem>
							<MenuItem value="HeadOffice">Head Office</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth sx={{ mb: 1 }} disabled={!selectedLocation || loading}>
						<InputLabel>Board Room Name</InputLabel>
						<Select
							value={selectedEvent?.roomId || ""}
							// onChange={(e) =>
							// 	setSelectedEvent({ ...selectedEvent, roomId: parseInt(e.target.value) })
							// }
							onChange={(e) => {
								const selectedId = parseInt(e.target.value);
								const selectedRoom = availableBoardrooms.find((room) => room.id === selectedId);
								if (selectedRoom) {
									setSelectedEvent({
										...selectedEvent,
										roomId: selectedRoom.id,
										roomName: selectedRoom.name, // <-- add this
									});
								}
							}}
						>
							{loading ? (
								<MenuItem disabled>Loading...</MenuItem>
							) : availableBoardrooms.length > 0 ? (
								availableBoardrooms.map((room) => (
									<MenuItem key={room.id} value={room.id}>
										{room.name}
									</MenuItem>
								))
							) : (
								<MenuItem disabled>No Rooms Available</MenuItem>
							)}
						</Select>
					</FormControl>

					<TextField
						label="Reserved By"
						fullWidth
						value={selectedEvent?.reservedBy || ""}
						sx={{ mb: 2 }}
					/>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<MobileDateTimePicker
							label="Meeting Start Time/Date"
							value={dayjs(selectedEvent?.start) || null}
							onChange={(date) =>
								setSelectedEvent({ ...selectedEvent, start: date })
							}
							sx={{ mb: 2, width: "100%" }}
							format="YYYY-MM-DD HH:mm:ss"
							minDate={today}
							minTime={minTime}
							maxTime={maxTime}
						/>
						<MobileDateTimePicker
							label="Meeting End Time/Date"
							value={dayjs(selectedEvent?.end) || null}
							onChange={(date) =>
								setSelectedEvent({ ...selectedEvent, end: date })
							}
							sx={{ mb: 2, width: "100%" }}
							format="YYYY-MM-DD HH:mm:ss"
							minDate={startDate || today}
							maxDate={startDate ? dayjs(startDate).endOf('day') : today}
							minTime={minTime}
							maxTime={maxTime}
						/>
					</LocalizationProvider>

					<TextField
						label="No of Persons"
						fullWidth
						value={selectedEvent?.noOfPersons || ''}
						onChange={handleNoOfPersonsChangeEdit}
						sx={{ mb: 1 }}
						error={!!editPersonsError}
						helperText={editPersonsError}
					/>

					<TextField
						label="Purpose of Meeting"
						fullWidth
						value={selectedEvent?.purposeOfMeeting || ""}
						onChange={(e) =>
							setSelectedEvent({ ...selectedEvent, purposeOfMeeting: e.target.value })
						}
						sx={{ mb: 1 }}
					/>

					<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
						<Button
							variant="contained"
							color="primary"
							onClick={handleEditReservation}
							disabled={!!editPersonsError || loading}
						>
							{loading ? "Saving..." : "Save"}
						</Button>
						<Button
							variant="contained"
							color="inherit"
							onClick={handleCloseModalEdit}
						>
							Close
						</Button>
					</Box>
				</Box>
			</Modal >

			{/* Change Request */}
			< Modal open={openModalRequest} onClose={handleCloseModalRequest} >
				<Box
					sx={{
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						width: 450,
						bgcolor: "background.paper",
						boxShadow: 24,
						p: 3,
						borderRadius: 2,
					}}
				>
					<Typography variant="h6" gutterBottom>
						Request to Change the Schedule
					</Typography>

					<FormControl fullWidth sx={{ mb: 2 }} disabled={selectedEvent?.status === "pending" || loading}>
						<InputLabel>Select Location</InputLabel>
						<Select
							value={selectedEvent?.selectedLocation || ""}
							onChange={(e) => {
								setSelectedEvent({ ...selectedEvent, selectedLocation: e.target.value });
							}}
						>
							<MenuItem value="Factory">Factory</MenuItem>
							<MenuItem value="HeadOffice">Head Office</MenuItem>
						</Select>
					</FormControl>

					<FormControl fullWidth sx={{ mb: 1 }} disabled={selectedEvent?.status === "pending" || !selectedLocation || loading}>
						<InputLabel>Board Room Name</InputLabel>
						<Select
							value={selectedEvent?.roomId || ""}
							// onChange={(e) => {
							// 	setSelectedEvent({ ...selectedEvent, roomName: e.target.value });
							// }}
							onChange={(e) => {
								const selectedId = parseInt(e.target.value);
								const selectedRoom = availableBoardrooms.find((room) => room.id === selectedId);
								if (selectedRoom) {
									setSelectedEvent({
										...selectedEvent,
										roomId: selectedRoom.id,
										roomName: selectedRoom.name, // <-- add this
									});
								}
							}}
						>
							{loading ? (
								<MenuItem disabled>Loading...</MenuItem>
							) : availableBoardrooms.length > 0 ? (
								availableBoardrooms.map((room) => (
									<MenuItem key={room.id} value={room.id}>
										{room.name}
									</MenuItem>
								))
							) : (
								<MenuItem disabled>No Rooms Available</MenuItem>
							)}
						</Select>
					</FormControl>


					<TextField
						label="Reserved By"
						fullWidth
						value={selectedEvent?.reservedBy || ""}
						sx={{ mb: 2 }}
						disabled={selectedEvent?.status === "pending"}
					/>

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<MobileDateTimePicker
							label="Meeting Start Time/Date"
							value={dayjs(selectedEvent?.start) || null}
							onChange={(date) =>
								setSelectedEvent({ ...selectedEvent, start: date })
							}
							sx={{ mb: 2, width: "100%" }}
							format="YYYY-MM-DD HH:mm:ss"
							minDate={today}
							disabled={selectedEvent?.status === "pending"}
							minTime={minTime}
							maxTime={maxTime}
						/>
						<MobileDateTimePicker
							label="Meeting End Time/Date"
							value={dayjs(selectedEvent?.end) || null}
							onChange={(date) =>
								setSelectedEvent({ ...selectedEvent, end: date })
							}
							sx={{ mb: 2, width: "100%" }}
							format="YYYY-MM-DD HH:mm:ss"
							minDate={startDate || today}
							disabled={selectedEvent?.status === "pending"}
							maxDate={startDate ? dayjs(startDate).endOf('day') : today}
							minTime={minTime}
							maxTime={maxTime}
						/>
					</LocalizationProvider>

					<TextField
						label="No of Persons"
						fullWidth
						value={selectedEvent?.noOfPersons || ''}
						onChange={handleNoOfPersonsChangeEdit}
						sx={{ mb: 1 }}
						disabled={selectedEvent?.status === "pending"}
						error={!!editPersonsError}
						helperText={editPersonsError}
					/>

					<TextField
						label="Purpose of Meeting"
						fullWidth
						value={selectedEvent?.purposeOfMeeting || ""}
						onChange={(e) =>
							setSelectedEvent({ ...selectedEvent, purposeOfMeeting: e.target.value })
						}
						disabled={selectedEvent?.status === "pending"}
						sx={{ mb: 1 }}
					/>

					<Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
						<Button
							variant="contained"
							color="primary"
							disabled={selectedEvent?.status === "pending" || !!editPersonsError}
							onClick={async () => {
								if (selectedEvent?.status === "pending") {
									toast.warning("You have already requested a change.");
									return;
								}

								const requestPayload = {
									reservationId: selectedEvent.reservationId,
									selectedLocation: selectedEvent.selectedLocation,
									roomName: selectedEvent.roomName,
									roomId: selectedEvent.roomId,
									reserveBy: selectedEvent.reservedBy,
									selectedStartDate: (new Date(selectedEvent.start).toLocaleString()),
									selectedEndDate: (new Date(selectedEvent.end).toLocaleString()),
									remarks: selectedEvent.remarks,
									noOfPersons: selectedEvent.noOfPersons,
									purposeOfMeeting: selectedEvent.purposeOfMeeting,
								};

								try {
									const response = await fetch(`${config.API_BASE_URL}/boardroomReservation/requestChange`, {
										method: "POST",
										headers: { "Content-Type": "application/json" },
										body: JSON.stringify(requestPayload),
									});

									const result = await response.json();
									// console.log("Server Response:", result);
									toast.success(result.message);
									handleCloseModalRequest()
								} catch (error) {
									console.error("Error requesting change:", error);
								}
							}}
						>
							{selectedEvent?.status === "pending" ? "Requested" : "Save"}
						</Button>

						<Button
							variant="contained"
							color="inherit"
							onClick={handleCloseModalRequest}
						>
							Close
						</Button>
					</Box>
				</Box>
			</Modal >
			<ToastContainer />
		</Box >
	);
};

export default ReservationSchedule;
